module.exports = __webpack_public_path__ + "static/media/BG1.91dc41dd.jpg";